
const Favourite = ()=>{
    return (
        <span>
            <a href="favourite">
                <i class="fas fa-hand-holding-heart"></i>
                <span className="badge badge-danger badge-counter"> 4 </span>
            </a>
        </span>
    )
}

export default Favourite